import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field, GradButton } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

export const SifreDialog = ({ onClose }) => {
  const [f, setF] = useState({ eski: "", yeni: "", tekrar: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const uyari = f.yeni && f.yeni.length < 6 ? "Yeni şifre en az 6 karakter olmalı" : f.tekrar && f.yeni !== f.tekrar ? "Yeni şifreler aynı değil" : "";
  const kaydet = async () => {
    setBusy(true);
    try { await api.post("/auth/sifre-degistir", { eski: f.eski, yeni: f.yeni }); toast.success("Şifreniz değişti"); onClose(); } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass max-w-sm" data-testid="sifre-dialog">
        <DialogHeader><DialogTitle className="font-head">Şifremi değiştir</DialogTitle></DialogHeader>
        <Field label="Mevcut şifre"><Input data-testid="sifre-eski" type="password" className="bg-white/5 h-11" value={f.eski} onChange={set("eski")} /></Field>
        <Field label="Yeni şifre"><Input data-testid="sifre-yeni" type="password" className="bg-white/5 h-11" value={f.yeni} onChange={set("yeni")} /></Field>
        <Field label="Yeni şifre (tekrar)"><Input data-testid="sifre-tekrar" type="password" className="bg-white/5 h-11" value={f.tekrar} onChange={set("tekrar")} /></Field>
        {uyari && <p className="text-xs text-red-300" data-testid="sifre-uyari">{uyari}</p>}
        <GradButton data-testid="sifre-kaydet" disabled={busy || !f.eski || !f.yeni || !!uyari || f.yeni !== f.tekrar} onClick={kaydet}>Kaydet</GradButton>
      </DialogContent>
    </Dialog>
  );
};
